import globalModule from '../../styles/global.module.scss';
import * as globalCss from '../../styles/global.scss';

// bit of a hack to allow disabling of two linters, while keeping import statements at the top of the file so tests will run
// eslint-disable-next-line no-unused-vars
const g = globalCss; // NOSONAR - import global styles to pull them into the build

const rawList =
  typeof process.env.CSS_CLASSES_UNPREFIXED === 'string'
    ? process.env.CSS_CLASSES_UNPREFIXED.split(',')
    : process.env.CSS_CLASSES_UNPREFIXED || [];

const raw = rawList
  .map(s => s.replace(/^\./, ''))
  .reduce((map, s) => (map[s] = s) && map, {});

// (1) If a corresponding global CSS module class is available, return it.
// (2) If prefixing is suppressed for the class, return the original.
// (3) Otherwise, add the prefix.
const resolveSelector = cssClass =>
  globalModule[cssClass] ||
  raw[cssClass] ||
  `${process.env.CSS_PREFIX}${cssClass}`;

export const get = function (...classes) {
  return classes
    .filter(c => typeof c === 'string')
    .map(resolveSelector)
    .filter(Boolean)
    .join(' ');
};

/**
 * Gets a style lookup that checks moduleStyles for a matching selector before exucuting global lookup
 * @param {*} cssModule CSS module to add to style lookup
 */
export const augment = function (cssModule = {}) {
  return function (...classes) {
    return classes
      .filter(c => typeof c === 'string')
      .map(c => cssModule[c] || resolveSelector(c))
      .filter(Boolean)
      .join(' ');
  };
};

const className = function () {
  return { className: get(...arguments) };
};

className.string = get;

const augmentClassName = function (cssModule = {}) {
  const getClassName = augment(cssModule);

  const objectGetter = function (...classes) {
    return {
      className: getClassName(...classes)
    };
  };

  objectGetter.string = getClassName;

  return objectGetter;
};

// expose chart color series as an array of hex color strings
const chartColors = globalModule.chartColors.split(',');

export { augmentClassName, chartColors, className };
